export const convertCoordinatesToPosition = (coordinates) => {
  const x = (Math.abs(coordinates.x) * 0.9 + 0.1) * Math.sign(coordinates.x);
  const y = (Math.abs(coordinates.y) * 0.75 + 0.25) * Math.sign(coordinates.y);
  const left = `${((x + 1) / 2) * 100}%`;
  const top = `${(1 - (y + 1) / 2) * 100}%`;
  return { top, left };
}


